import axiosApiClient from "../axios";

const refreshTokenName = process.env.REACT_APP_REFRESH_TOKEN_KEY || 'refreshToken';
const accessTokenName = process.env.REACT_APP_AUTH_TOKEN_KEY || 'token';

// Utility function to clear all authentication data
export const clearAllAuthData = () => {
    console.log('Clearing all authentication data...');

    // Clear tokens
    localStorage.removeItem(accessTokenName);
    localStorage.removeItem(refreshTokenName);

    // Clear user data
    localStorage.removeItem('userDetails');
    localStorage.removeItem('loggedInUserDetail');
    localStorage.removeItem('isAuthenticated');

    // Clear session storage
    sessionStorage.clear();

    // Clear any other potential auth-related items
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');

    console.log('All authentication data cleared');
};

export const login = async (username, password) => {
    try {
        const response = await axiosApiClient.post('/api/auth/login', {username, password});
        const {token, refreshToken, passwordChangeRequired, message} = response.data;
        if (token && refreshToken) {
            localStorage.setItem(accessTokenName, token);
            localStorage.setItem(refreshTokenName, refreshToken);
            return {
                token,
                refreshToken,
                passwordChangeRequired: passwordChangeRequired || false,
                message: message || 'Login successful'
            };
        } else {
            throw new Error('Invalid response from server');
        }
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Login failed');
    }
};

export const logout = async () => {
    try {
        const token = localStorage.getItem(accessTokenName);
        if (token) {
            // Try to call logout endpoint, but don't fail if it doesn't work
            try {
                await axiosApiClient.post('/api/auth/logout', {});
                console.log('Logout API call successful');
            } catch (apiError) {
                console.warn('Logout API call failed, but continuing with local cleanup:', apiError);
            }
        }
    } catch (err) {
        console.error('Logout error:', err);
    } finally {
        // Always clear all authentication data regardless of API call success
        clearAllAuthData();
    }
};

export const loginByRefreshToken = async () => {
    const existingRefreshToken = localStorage.getItem(refreshTokenName);
    if (!existingRefreshToken) {
        throw new Error('REFRESH TOKEN NOT FOUND');
    }
    try {
        const response = await axiosApiClient.post('/api/auth/refresh-token', {refreshToken: existingRefreshToken});
        const {token, refreshToken} = response.data;
        if (token && refreshToken) {
            localStorage.setItem(accessTokenName, token);
            localStorage.setItem(refreshTokenName, refreshToken);
            return response.data;
        } else {
            throw new Error('Invalid response from server');
        }
    } catch (err) {
        localStorage.removeItem(accessTokenName);
        localStorage.removeItem(refreshTokenName);
        throw new Error(err.response?.data?.message || 'Failed to refresh token');
    }
};

export const register = async (user) => {
    try {
        return await axiosApiClient.post('/api/auth/register', user);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Registration failed');
    }
};

// Admin-style reset: set default password for a user by email
export const requestPasswordReset = async (email) => {
    try {
        console.log('Requesting password reset for email:', email);
        return await axiosApiClient.post('/api/auth/user-password-reset', { email });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to request password reset');
    }
};

// Reset password using a reset token
export const resetPasswordWithToken = async (token, newPassword) => {
    try {
        return await axiosApiClient.post('/api/auth/reset-password', {
            token,
            newPassword,
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to reset password');
    }
};

export const verifyOtp = async (email, otp) => {
    try {
        return await axiosApiClient.post('/api/auth/verify-otp', { email, otp });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to verify OTP');
    }
};